module.exports = __webpack_public_path__ + "static/media/road-america-2024@2x.73eca1ac.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/road-america-2024@2x.png
// module id = 1147
// module chunks = 0